<template>
    <fragment>
        <li @click="setCoordinates">
            <v-icon left color="light-blue">ter-street</v-icon>
            Náhled do katastru
        </li>
    </fragment>
</template>
<script>
    export default {
        name: 'map-cadastre-context-menu',
        props: [
            'data',
        ],
        methods: {
            setCoordinates() {
                this.$store.dispatch('cadastre/setCoordinates', this.data.coordinates);
            },
        },
    }
</script>
